import { ReactNode } from "react";

export const PageContentRight = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};
